import { useTranslation } from 'react-i18next';
import {
  Attachment,
  AttachmentContent,
  AttachmentDescription,
  AttachmentMedia,
  AttachmentTitle,
  ChatAttachmentIcon
} from '@bliks-io/ui';
import type { TranscriptFilePart } from './parts';

/**
 * A file the user attached, as the transcript replays it (plan 012 §2).
 *
 * Deliberately INERT: there is nothing to open. The message carries a handle,
 * never the bytes, and the object behind it is ephemeral — the upload exists to
 * be read by the model during the conversation, not to become a downloadable
 * artifact of the tenant. The chip is here so a reloaded turn still shows what
 * the question was asked about.
 */
export const ChatAttachmentBlock = ({ part }: { part: TranscriptFilePart }) => {
  const { t } = useTranslation();

  return (
    <Attachment size="sm">
      <AttachmentMedia>
        <ChatAttachmentIcon mediaType={part.mediaType} />
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle>{part.filename || t('chat.attachment.fallbackName')}</AttachmentTitle>
        <AttachmentDescription>{t('chat.attachment.label')}</AttachmentDescription>
      </AttachmentContent>
    </Attachment>
  );
};
